import { useState, useEffect } from "react";
import { useFetch } from "../../../common/hooks/useFetch.js";
import { countFaultsService } from "../sevices/countFaults.service.js";
import debounce from "lodash.debounce";

export const useCountFaultsQuery = (filters) => {
  const fetchData = useFetch();
  const [countFaults, setCountFaults] = useState([]);
  const [loading, setLoading] = useState(false);
  const [refresh, setRefresh] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [total, setTotal] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  useEffect(() => {
    const fetchCountFaults = async () => {
      try {
        setLoading(true);
        const response = await countFaultsService(fetchData)({
          filters: { page: currentPage, limit: 20, ...filters },
        });
        setCountFaults(response.data);
        setTotal(response.total);
        setTotalPages(response.totalPages);
      } catch (error) {
        console.error("Error fetching count faults:", error);
      } finally {
        setLoading(false);
      }
    };

    const debounced = debounce(fetchCountFaults, 500);
    debounced();
    return () => {
      debounced.cancel();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [refresh, filters, currentPage]);

  return {
    countFaults,
    loading,
    total,
    totalPages,
    currentPage,
    onChangePage: (page) => setCurrentPage(page),
    refresh: () => setRefresh((prev) => !prev),
  };
};
